// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./placeholder.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".b9F2CZ{width:100%;background-position:50%;background-size:cover}.b9F2CZ::before{content:'';display:block;padding-top:75%}.fflwGW::before{padding-top:100%}.e7f6P7::before{padding-top:56.25%}.st8N6T{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ")}.X93_XT{position:relative;overflow:hidden;background-color:#eeeeee}.X93_XT::after{content:'';position:absolute;top:0;left:0;bottom:0;right:0;background-image:linear-gradient(to right, rgba(225,225,225,0), #e0e0e0 51%, rgba(231,231,231,0));animation-name:x119u6;animation-duration:1.5s;animation-iteration-count:infinite}@keyframes x119u6{0%{transform:translateX(-100%)}100%{transform:translateX(100%)}}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imgCover": "b9F2CZ",
	"imgCoverSquare": "fflwGW",
	"imgCoverWide": "e7f6P7",
	"imgCoverPlaceholder": "st8N6T",
	"imgCoverLoading": "X93_XT",
	"loading": "x119u6"
};
export default ___CSS_LOADER_EXPORT___;
